import React from 'react';
import { DefaultCard, DottedHr, colors } from 'design-system';
import { makeStyles, createStyles, Grid, Box } from '@material-ui/core';
import { getBarDetails } from './helperFunctions';

const useStyles = makeStyles(() => {
  return createStyles({
    totalText: {
      color: colors.madison,
      fontSize: 12,
      fontWeight: 700,
    },
    percentageText: {
      color: colors.madison,
      fontSize: 13,
      fontWeight: 500,
    },
    rowSpace: {
      marginTop: '15px',
    },
    boxGrey: {
      flexGrow: 1,
      height: 8,
      borderRadius: 30,
      backgroundColor: colors.gallery,
      padding: 0,
      marginRight: '20px',
    },
    boxColor: {
      height: 8,
      borderRadius: 30,
    },
  });
});

type Props = {
  totalParticipation: number;
};

const BeneficiaryPercentageCard = ({
  totalParticipation,
}: Props): JSX.Element => {
  const classes = useStyles();
  const { color, value } = getBarDetails(totalParticipation);
  return (
    <DefaultCard
      title="Listado de beneficiarios (agrega máximo 5 personas)"
      data-testid="card"
    >
      <DottedHr />
      <Grid item container xs={12} className={classes.rowSpace}>
        <Grid item xs={12} md={4} xl={3}>
          <span className={classes.totalText}>(%) TOTAL ASIGANDO</span>
        </Grid>
        <Grid item xs={12} md={8} xl={9}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box className={classes.boxGrey}>
              <Box
                className={classes.boxColor}
                sx={{
                  bgcolor: color,
                  width: `${value}%`,
                }}
              />
            </Box>
            <Box>
              <span className={classes.percentageText}>
                {totalParticipation} %
              </span>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </DefaultCard>
  );
};

export default BeneficiaryPercentageCard;
